import type { SVGProps } from 'react'

/**
 * THIS FILE IS AUTO GENERATED!
 * Direct changes to this file will be overwritten on next icons:build execution.
 * Changes have to be made in the assets/*.svg file.
 * Afterwards execute the icons:build command.
 */
export const ChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      d="M14 7l-5 5m5 5l-4.818-4.818"
      stroke="currentColor"
      strokeWidth={2}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="square"
    />
  </svg>
)
